import { Button } from '@mui/material';
import { PhoenixGrid } from '@shared/components/grid/PhoenixGrid';
import { SectionTitle } from '@shared/components/SectionTitle';
import { ButtonsSection } from '@styles/DealSheet/DealSheetStyles';
import { IDSHistoryProps } from '../interfaces';
import { historyColumns } from '../constants';

export const DealSheetHistory = ({ data, onClick, historyIndex, handleCreateNew, requestNavigateBtn }: IDSHistoryProps) => {
  return (
    <div>
      <SectionTitle
        title="DealSheet History"
        variant="h2"
      />
      <ButtonsSection mb='10px' justifyContent='space-between'>
        <Button variant="outlined" onClick={handleCreateNew}>+ New</Button>
        <Button variant="outlined" onClick={requestNavigateBtn}>+ Negative</Button>
      </ButtonsSection>
      <PhoenixGrid
        autoHeight
        withHeader
        noButton
        columns={historyColumns}
        rows={data || []}
        selectionModel={data.length && (historyIndex !== -1 ? data[historyIndex]?.id : data[0]?.id)}
        pageSize={5}
        onSelectionModelChange={onClick}
      />
    </div>
  );
};
